import React from 'react';
import { HelpCenter, } from '@mui/icons-material';
import BLOCKS from '../../../../../Packages/blocks';
// { label: 'ProgressBar', icon: <ProgressBarOutlined />, block: () => ({}) },
// { label: 'LoopContainer', icon: <ViewListOutlined />, block: () => ({}) },
export const BUTTONS = BLOCKS.map((b) => ({
    label: b.label,
    icon: b.icon || React.createElement(HelpCenter, null),
    block: () => ({
        type: b.type,
        data: b.defaultData || {},
    }),
}));
//# sourceMappingURL=buttons.js.map